export default __webpack_public_path__ + "4dd7bb1ce22cdb539edb71acf0c04fef.png";